/** Strict 3-0-1-0 tempo prescription for calibration sets (seconds per phase). */
export const TEMPO_PRESCRIPTION = [3, 0, 1, 0] as const

export type TempoPhase =
  | 'prep'
  | 'countdown'
  | 'eccentric'
  | 'isometric'
  | 'concentric'
  | 'await_confirm'
  | 'reset'
  | 'idle'

/** Seconds shown during pre-set countdown (3 → 2 → 1 → GO). */
export const SET_COUNTDOWN_SECONDS = 3

/** Auto = metronome counts reps (touch floor). Manual = user confirms each rep (mouse/keyboard). */
export type RepAdvanceMode = 'auto' | 'manual'

export const TEMPO_PHASE_MS = {
  eccentric: TEMPO_PRESCRIPTION[0] * 1000,
  isometric: 120,
  concentric: TEMPO_PRESCRIPTION[2] * 1000,
  reset: 0,
} as const

/** Full rep cycle duration: 3 + 0 + 1 + 0 = 4 s */
export const EXPECTED_REP_CYCLE_MS = TEMPO_PRESCRIPTION.reduce<number>((sum, s) => sum + s, 0) * 1000

/** V_d thresholds (seconds). */
export const RUSHER_VD_THRESHOLD_S = -1.5
export const STALL_VD_THRESHOLD_S = 2.0

export const RUSHER_VD_THRESHOLD_MS = RUSHER_VD_THRESHOLD_S * 1000
export const STALL_VD_THRESHOLD_MS = STALL_VD_THRESHOLD_S * 1000

export type RepConfirmationSource = 'screen_tap' | 'volume_key' | 'vocal_peak'

export type TempoComplianceFlag = 'compliant' | 'rusher' | 'stall'

export type RepVelocitySample = {
  rep_index: number
  /** V_d in ms: Δt_actual − T_expected */
  delta_ms: number
  actualIntervalMs: number
  expectedIntervalMs: number
  source: RepConfirmationSource
  complianceFlag: TempoComplianceFlag
  phase: 'lockout'
}

export type CalibrationSetResult = {
  repsCompleted: number
  targetReps: number
  velocityDeviationHistory: RepVelocitySample[]
  tempoComplianceRate: number
  /** True when a stall triggered muscular failure (0 RIR). */
  muscularFailure: boolean
  rir: number
  /** User-entered working load for compound calibration sessions. */
  workingWeightKg?: number
}
